import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import confirmImage from 'legacy/assets/img/signup-confirm.png'
import { ButtonAction } from 'legacy/components/Button/ButtonAction'
import { resendEmail } from 'legacy/services/account'
import { screen } from 'legacy/styles/screen'
import sentry from 'legacy/utils/sentry'

const Title = styled.div`
  color: ${getToken('color-neutral-white')};
  font-size: 24px;
  font-weight: bold;
  line-height: 1.3em;
  text-align: center;

  ${screen.md} {
    font-size: 40px;
    margin-bottom: 14px;
  }
`

const ConfirmWrapper = styled.div`
  text-align: center;
  width: 100%;

  ${screen.md} {
    width: auto;
  }
`

const Text = styled.div`
  color: ${getToken('color-neutral-white')};
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
  margin-top: 20px;
  padding: 0 20px;
  margin: auto;

  ${screen.md} {
    font-size: 20px;
    padding: 0;
    max-width: 450px;
  }
`

const Button = styled(ButtonAction)`
  height: 35px;
  width: 216px;
  font-size: 12px;
  font-weight: bold;
  line-height: 10px;
  text-align: center;
  display: inline-block;
  margin-top: 30px;
`

function SignupSuccessPage({ email }) {
  const [sentCheck, setSentCheck] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setSentCheck(false)
    }, 3000)
    return () => clearTimeout(timer)
  }, [])

  function handleResendEmail(email) {
    const data = {
      email: email,
    }

    resendEmail(data)
      .then(() => {
        sentry.log('Email sent, Please check your inbox')

        setSentCheck(true)
        setTimeout(() => {
          setSentCheck()
        }, 3000)
      })
      .catch(({ response }) => {
        if (response.status === 404) {
          sentry.log('There is no account with this email')
        } else if (response.status === 422) {
          sentry.log('Email field is required')
        } else {
          sentry.log('Cannot resend email')
        }
      })
  }

  return (
    <ConfirmWrapper>
      <Title>Check your email</Title>
      <img
        height="1"
        width="1"
        alt=""
        src="https://insight.adsrvr.org/track/pxl/?adv=l6j1ni3&ct=0:wqmirf0&fmt=3"
      />
      <img src={confirmImage} alt="signup" width="240" />
      <Text>
        We sent an email to verify your address.
        <br />
        Please check your inbox and click on the link to activate your account.
      </Text>
      <Button square activated onClick={() => handleResendEmail(email)}>
        {sentCheck ? '✔' : 'RESEND EMAIL'}
      </Button>
    </ConfirmWrapper>
  )
}

SignupSuccessPage.defaultProps = {
  email: undefined,
  accountType: undefined,
}

SignupSuccessPage.propTypes = {
  email: PropTypes.string,
  accountType: PropTypes.string,
}

export default SignupSuccessPage
